import { render, staticRenderFns } from "./pageCount.vue?vue&type=template&id=74a75262&scoped=true&"
import script from "./pageCount.vue?vue&type=script&lang=js&"
export * from "./pageCount.vue?vue&type=script&lang=js&"
import style0 from "./pageCount.vue?vue&type=style&index=0&id=74a75262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a75262",
  null
  
)

export default component.exports